import React from 'react';
import Chip from 'Chip';
import styles from './index.css';
import PropTypes from 'prop-types';

import HeaderLogo from './logo/';
import SearchTop from './search/';

/**
 * 定义 Header 组件
 */
class Header extends React.PureComponent {
    /**
     * 渲染组件
     */
    render() {
        const { content } = this.props;

        return (
            <div className={styles.headerBox}>
                <div className={styles.container}>
                    <HeaderLogo content={content} />
                    <div className={styles.searchBox}>
                        <SearchTop />
                    </div>
                </div>
            </div>
        );
    }
}

/**
 * 定义组件属性类型
 * */
Header.propTypes = { content: PropTypes.array };

/**
 * 定义组件默认属性
 * */
Header.defaultProps = {};

export { Header };
export default Header;
